/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import { TwoColOneAd } from "./two-col-one-ad";
import { HalfImageSlider } from "./half-screen-slider.js";
import { FullscreenSimpleSlider } from "./fullscreen-simple-slider.js";
import { FullscreenLinearGallerySlider } from "./fullscreen-linear-gallery-slider.js";
import { ThreeCol } from "./three-col";
import { TwoCol } from "../two-col/two-col.js";
import { LShapeOneWidget } from "../l-shape/l-shape-one-widget.js";
import { FullImageSlider } from "./full-screen-slider.js";
import { TwoColCarousel } from "./two-col-carousel.js";
import { TwoColHighlight } from "./two-col-highlight.js";
import { FourColGrid } from "./four-col-grid.js";
import { AdSlotRow } from "./ad-slot-row";
import { CustomWidgetRow } from "./custom-widget-row";
import { OneColStoryList } from "./one-col-story-list.js";
import { SliderCollectionOfCollections } from "./slider-collection-of-collections.js";
import { ThreeColGrid } from "./../collection-templates/three-col-grid/three-col-grid.js";
import { AuthorsListComponent } from "../pages/authors-list";

import {
  ThreeColGrid as ArrowThreeColGrid,
  FourColGrid as ArrowFourColGrid,
  ElevenStories as ArrowElevenStories,
  OneColStoryList as ArrowOneColStoryList,
  TwoColThreeStories as ArrowTwoColThreeStories,
  ThreeColSixStories as ArrowThreeColSixStories,
  TwoColFourStories as ArrowTwoColFourStories,
  ThreeColSevenStory as ArrowThreeColSevenStory,
  CollectionFilter as ArrowCollectionFilter,
  TagIntroductionCard as ArrowTagIntroductionCard,
  AuthorIntroductionCard as ArrowAuthorIntroductionCard,
  HalfScreenSlider as ArrowHalfScreenSlider,
  FullScreenSlider as ArrowFullScreenSlider,
  FourStorySlider as ArrowFourStorySlider,
  PageIntroductionCard as ArrowPageIntroductionCard,
  MagazineHeaderCard as ArrowMagazineHeaderCard,
  MagazineEditions as ArrowMagazineEditions,
  MagazineWidget as ArrowMagazineWidget,
  TwoColSixStories as ArrowTwoColSixStories,
  OpinionCollection as ArrowOpinionCollection,
  TwoColFourStoryHighlight as ArrowTwoColFourStoryHighlight,
  FourColSixteenStories as ArrowFourColSixteenStories,
  FourColFiveStories as ArrowFourColFiveStories
} from "@quintype/arrow";

import { PageIntroduction } from "../molecules/introduction-card";
import { arrowWrapper } from "./arrow/index.js";
import SearchPageLayout from "../pages/search-page/search-layout";
import WithSubsequentLoad from "../hoc-components/with-subsequent-load";

// setting max story limit for arrow components
const wrapperForStoryLimits = Component => {
  const arrowWrapperWithStoryLimits = arrowWrapper(Component);

  arrowWrapperWithStoryLimits.storyLimit = 16;
  return arrowWrapperWithStoryLimits;
};

export default {
  HalfImageSlider,
  TwoColOneAd,
  FullscreenSimpleSlider,
  ThreeCol,
  FullscreenLinearGallerySlider,
  TwoCol,
  TwoColHighlight,
  TwoColCarousel,
  LShapeOneWidget,
  FullImageSlider,
  FourColGrid,
  OneColStoryList,
  SliderCollectionOfCollections,
  ThreeColGrid,
  ArrowCollectionFilter: wrapperForStoryLimits(ArrowCollectionFilter),
  ArrowThreeColGrid: wrapperForStoryLimits(WithSubsequentLoad(ArrowThreeColGrid, 3)),
  ArrowFourColGrid: wrapperForStoryLimits(WithSubsequentLoad(ArrowFourColGrid, 4)),
  ArrowFourColFiveStories: wrapperForStoryLimits(WithSubsequentLoad(ArrowFourColFiveStories, 5)),
  ArrowOneColStoryList: wrapperForStoryLimits(WithSubsequentLoad(ArrowOneColStoryList, 6)),
  ArrowOpinionCollection: wrapperForStoryLimits(WithSubsequentLoad(ArrowOpinionCollection, 6)),
  ArrowThreeColSixStories: wrapperForStoryLimits(ArrowThreeColSixStories),
  ArrowTwoColThreeStories: wrapperForStoryLimits(ArrowTwoColThreeStories),
  ArrowElevenStories: wrapperForStoryLimits(ArrowElevenStories),
  ArrowTwoColFourStories: wrapperForStoryLimits(ArrowTwoColFourStories),
  ArrowHalfScreenSlider: wrapperForStoryLimits(ArrowHalfScreenSlider),
  ArrowFullScreenSlider: wrapperForStoryLimits(ArrowFullScreenSlider),
  ArrowFourStorySlider: wrapperForStoryLimits(ArrowFourStorySlider),
  ArrowThreeColSevenStory: wrapperForStoryLimits(ArrowThreeColSevenStory),
  ArrowTagIntroductionCard: PageIntroduction(ArrowTagIntroductionCard),
  ArrowAuthorIntroductionCard: PageIntroduction(ArrowAuthorIntroductionCard),
  ArrowPageIntroductionCard: PageIntroduction(ArrowPageIntroductionCard),
  AuthorsListComponent: arrowWrapper(AuthorsListComponent),
  ArrowMagazineHeaderCard: arrowWrapper(ArrowMagazineHeaderCard),
  ArrowMagazineEditions: arrowWrapper(ArrowMagazineEditions),
  ArrowMagazineWidget: arrowWrapper(ArrowMagazineWidget),
  ArrowTwoColSixStories: arrowWrapper(ArrowTwoColSixStories),
  ArrowTwoColFourStoryHighlight: arrowWrapper(ArrowTwoColFourStoryHighlight),
  ArrowFourColSixteenStories: arrowWrapper(ArrowFourColSixteenStories),
  Leaderboard: AdSlotRow,
  SuperLeaderboard: AdSlotRow,
  Billboard: AdSlotRow,
  Custom: AdSlotRow,
  widget: CustomWidgetRow,
  SearchPage: SearchPageLayout,
  defaultTemplate: ThreeCol
};
